import { Component, signal } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { ToastTray } from '@shared/components'
import { Sidebar } from './components/sidebar/sidebar'
import { Header } from './components/header/header'

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, Sidebar, Header, ToastTray],
  templateUrl: './layout.html'
})
export class Layout {
  sidebarOpen = signal(false)

  toggleSidebar(): void {
    this.sidebarOpen.update(open => !open)
  }

  closeSidebar(): void {
    this.sidebarOpen.set(false)
  }
}
